<router-outlet></router-outlet>
<p-toast></p-toast>
<p-confirmDialog header="Confirmation" appendTo="body"></p-confirmDialog>
<p-confirmDialog
  key="canDeactivateConfirmDialog"
  header="Confirmation"
  appendTo="body"></p-confirmDialog>
<p-confirmPopup></p-confirmPopup>
